import { createFileRoute } from "@tanstack/react-router";

import { PractitionerAccountPage } from "@/pages/account/PractitionerAccountPage.tsx";

export const Route = createFileRoute("/_practitioner/account")({
  component: PractitionerAccountPage,
});
